// extracted by mini-css-extract-plugin
export default {"text":"Home_text__N22hs","subtitle":"Home_subtitle__KoBhc","photo":"Home_photo__EX+4C","paw":"Home_paw__gNBjY","paw2":"Home_paw2__KTvEz"};